import ProductBrand from './ProductBrand'

export default ProductBrand
